import React from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Contests from './Contests';
import logo from './../assets/images/codeforces1.png';
import Grid from '@material-ui/core/Grid';
console.log(logo)

// Now this is the base of the app
export default class App extends React.Component {
	notifyMe=(text)=>{
		console.log("This notify function is working. Text : -->" + text);
		// if (!("Notification" in window)) {
  //   alert("This browser does not support desktop notification");
  // }

  // // Let's check whether notification permissions have already been granted
  // else if (Notification.permission === "granted") {
  //   // If it's okay let's create a notification
  //   var notification = new Notification("Hi there!");
  // }

  // // Otherwise, we need to ask the user for permission
  // else if (Notification.permission !== "denied") {
  //   Notification.requestPermission().then(function (permission) {
  //     // If the user accepts, let's create a notification
  //     if (permission === "granted") {
  //       var notification = new Notification("Hi there!");
  //     }
  //   });
  // }
	}
	render() {
		const jsx= (
			<Container>
			<Grid container className="heading">
			<Grid item md={12}>
			<Typography variant="h3" gutterBottom>
        	<img src={logo} alt="Logo" className="logo-codeforces" />Upcoming Code<span className="second-color">forces</span> Contests
        	</Typography>
        	</Grid>
        	</Grid>
			{/*List of Contest*/}
			<Contests notifyMe={this.notifyMe}/>
			</Container>
			)
		return jsx
	}
}
